import { render } from "./TacticContextTypeCard.vue?vue&type=template&id=0709dcea"
import script from "./TacticContextTypeCard.vue?vue&type=script&lang=js"
export * from "./TacticContextTypeCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__